/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * February 2026
 */

import React from 'react';
import {withRouter} from "react-router";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import API from "../../lib/api/NbioApi";
import {toast} from "sonner";

//components
import DragZone from "../ui/Dropzone";
import PropTypes from "prop-types";



class CategoryImageUploader extends React.Component{
    constructor(p) {
        super(p);
        this.state = {
            categoryImage: null,
            isUploading:false
        }

        this.onClickUploadImage         = this.onClickUploadImage.bind(this);
        this.onImageDropped             = this.onImageDropped.bind(this);
    }

    onImageDropped = (image) => {
        this.setState({categoryImage:image});
    }

    onClickUploadImage = () => {
        const categoryId = this.props.category._id
        const image = this.state.categoryImage;
        if(image){
            this.setState({isUploading:true});
            const loadingToastCategoryImage = toast.loading('Subiendo la imagen...', { duration: 1000 });

            //Remove prefix data image
            const regex = /data:.*base64,/;
            const base64Img = image.replace(regex,"");

            const data = {
                images:[base64Img]
            }

            API.categories.updateCategory(categoryId,data).then(res => {
                toast.success('Imagen actualizada...', { id: loadingToastCategoryImage })
                this.setState({isUploading:false});
                this.props.onImageUploaded(categoryId);
            }).catch((ex) => {
                this.setState({isUploading:false});
                let errorMsg = 'Hubo un error al actualizar la imagen';
                try{
                    errorMsg = ex.response.data.error_es;
                }catch(ex){
                    errorMsg = 'Servicio no disponible';
                }
                toast.error(errorMsg,{id:loadingToastCategoryImage});
            })
        }else{
            this.setState({isUploading:false});
            toast.error('No has agregado la imagen de la categoría');
        }
    }


    render(){
        const category = this.props?.category;
        const imageObj = category?.images?.length > 0 ? category?.images[0] : {};
        const image = imageObj?.url ? imageObj?.url : "";
        const isUploading = this.state.isUploading;

        return(
            <Card.Body>
                <DragZone disabled={isUploading}
                          onImageDropped={this.onImageDropped}
                          preSelectedImage={image}>
                </DragZone>

                <div className={'d-flex justify-content-end mt-3'}>
                    <Button onClick={() => this.onClickUploadImage()}
                            disabled={isUploading}>Subir imagen</Button>
                </div>
            </Card.Body>
        )
    }
}

export default withRouter(CategoryImageUploader);
CategoryImageUploader.propTypes    = {
    category:           PropTypes.any,
    categoryId:         PropTypes.string,
    onImageUploaded:    PropTypes.any,
}
CategoryImageUploader.defaultProps = {
    category:           {},
    categoryId:         '',
    onImageUploaded:    () => {},
}
